<template>
    <v-tooltip bottom v-if="visible">
        <template v-slot:activator="{ on, attrs }">
            <v-chip
                v-bind="attrs"
                v-on="on"
                x-small
                label
                role="status"
                aria-live="polite"
                class="mr-2 live-updates-chip"
                :color="chipColor"
                text-color="white"
                e2e-live-updates-indicator>
                <span class="live-updates-dot mr-1" :class="{ pulse: pulsing }"></span>
                {{ label }}
            </v-chip>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
import { getStatus, onStatus, isPushUiEnabled, onPushUiEnabled } from '@/push'

export default {
    name: 'LiveUpdatesIndicator',
    data() {
        return {
            status: getStatus(),
            transport: null,
            pushUiEnabled: isPushUiEnabled(),
            unsub: null,
            unsubUi: null
        }
    },
    computed: {
        visible() {
            // Only after a real push connect this session — never "Connecting…" forever on old BE.
            return this.$auth?.isAuthenticated && this.pushUiEnabled
        },
        label() {
            if (this.status === 'connected') return 'Live updates on'
            if (this.status === 'reconnecting') return 'Reconnecting…'
            return 'Connecting…'
        },
        chipColor() {
            return this.status === 'connected' ? 'success' : 'amber darken-2'
        },
        pulsing() {
            return this.status === 'connecting' || this.status === 'reconnecting'
        },
        tooltip() {
            if (this.transport === 'ws') return 'Push via WebSocket'
            if (this.transport === 'sse') return 'Push via SSE'
            return 'Connecting live updates…'
        }
    },
    created() {
        this.unsub = onStatus(payload => {
            this.status = payload.status
            this.transport = payload.transport
        })
        this.unsubUi = onPushUiEnabled(enabled => {
            this.pushUiEnabled = enabled
        })
    },
    beforeDestroy() {
        if (this.unsub) {
            this.unsub()
            this.unsub = null
        }
        if (this.unsubUi) {
            this.unsubUi()
            this.unsubUi = null
        }
    }
}
</script>

<style scoped>
.live-updates-chip {
    height: 22px;
    font-weight: 500;
}
.live-updates-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.95;
}
.live-updates-dot.pulse {
    animation: liveUpdatesPulse 1.2s ease-in-out infinite;
}
@keyframes liveUpdatesPulse {
    0%,
    100% {
        opacity: 0.35;
        transform: scale(0.85);
    }
    50% {
        opacity: 1;
        transform: scale(1.15);
    }
}
@media (prefers-reduced-motion: reduce) {
    .live-updates-dot.pulse {
        animation: none;
    }
}
</style>
